export function SetPatientsGenerated(data) {
  return {
    type: 'PATIENTS_GENERATED',
    patientsGenerated: data || [],
  };
}
